<template>
  <div class="example-preview table-responsive overflow-auto mt-3">
    <table class="table text-left table-hover table-bordered table-vertical-center b-table">
      <thead>
      <tr style="background-color: #472F92; color: white">
        <th>STT</th>
        <th>Tên OKR</th>
        <th>Phòng ban</th>
        <th>Quý</th>
        <th>Phân loại</th>
        <th>Nhân sự</th>
        <th style="width: 150px">EXP đạt / được giao</th>
        <th>Người lead</th>
        <th style="width: 290px">Trạng thái</th>
        <th class="text-center" style="width: 150px">Hành động</th>
      </tr>
      </thead>
      <tbody>
      <template v-if="dataOkrs?.length > 0">
        <tr v-for="(item, index) in dataOkrs" :key="item.id">
          <td>{{ getIndex(page, index, 20) }}</td>
          <td>{{ item.name ?? '' }}</td>
          <td>{{ item?.department ?? '' }}</td>
          <td>
            <span style="white-space: nowrap">{{ item?.fiscalQuarter }}</span>
          </td>
          <td>
            <span :class="item.colorType" style="white-space: nowrap">{{ item?.type }}</span>
          </td>
          <td>
            <el-tooltip class="item" effect="dark" placement="top">
              <template #content>
                <div style="display: flex; flex-direction: column; gap: 8px 0">
                  <span v-for="item in item.humans" :key="item.id">{{item.name}}</span>
                </div>
              </template>
              <span class="text-primary" style="text-decoration: underline; cursor: pointer">{{ item?.human }}</span>
            </el-tooltip>
          </td>
          <td>{{ item?.exp }}</td>
          <td>{{ item?.leader }}</td>
          <td :id="item.status === 6 ? 'success-okr' : item.status === 1 ? 'fail-okr' : item.status === 0 ? 'normal-okr' : 'warning-okr'">
            <el-select v-model="item.status" placeholder="Chọn quý" class="w-100" @change="updateStatusOkr(item)">
              <el-option
                  v-for="item in statusOkrOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </td>
          <td class="text-center">
            <div class="d-flex align-content-center justify-content-center">
              <button class="btn btn-outline-warning p-0 mr-2"
                      title="Sửa"
                      type="button" @click="updateOkr(item)">
                <i class="el-icon-edit-outline p-2"></i>
              </button>
              <button class="btn btn-outline-primary p-0 mr-2"
                      title="Chia Exp" type="button"
                      @click="handleShareExp(item)"><i
                  class="el-icon-pie-chart p-2"></i></button>
              <button class="btn btn-outline-danger p-0 mr-2"
                      title="Xoá" type="button"
                      @click="confirmDeleteOkr(item)"><i
                  class="el-icon-delete p-2"></i></button>
            </div>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="11" class="text-center">Chưa có dữ liệu</td>
        </tr>
      </template>
      </tbody>
    </table>
    <el-dialog
        class="responsive" v-if="isEdit" width="40%"
        :visible.sync="isEdit" :show-close="false"
        append-to-body :title="`Sửa okr ${okrSelected.name}`" destroy-on-close
    >
      <hr style="margin-top: -20px; border: 1px solid lightgray"/>
      <FormOKR
          @closeDialog="isEdit = false"
          @getListOkr="getListOkr"
          :okr-id="okrSelected.id"
      />
    </el-dialog>
    <el-dialog
        class="responsive" v-if="isShare" width="40%"
        :visible.sync="isShare" :show-close="false"
        append-to-body :title="`Chia EXP ${okrSelected.name}`" @close="false"
    >
      <hr style="margin-top: -20px; border: 1px solid lightgray"/>
      <TableShareExp :data-exp="okrSelected ?? []" @getListOkr="getListOkr" @closeDialog="isShare = false"/>
    </el-dialog>
    <el-dialog
        class="responsive" v-if="isDelete" width="30%"
        :visible.sync="isDelete" :show-close="false"
        append-to-body title="Xoá okr"
    >
      <hr style="margin-top: -20px; border: 1px solid lightgray"/>
      <span style="word-break: break-word">Bạn có chắc chắn muốn xoá okr <span style="font-weight: 700">{{okrSelected.name}}</span> không?</span>
      <div class="d-flex align-items-center justify-content-end mt-4">
        <el-button type="info" @click="isDelete = false">Đóng</el-button>
        <el-button type="primary" @click="handleDeleteOkr" :loading="disabledSubmit" :disabled="disabledSubmit">Xác nhận</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FormOKR from "./FormOKR.vue";
import TableShareExp from "./TableShareExp.vue";
import {statusOkrOption} from "@/common/define";
import {DELETE_OKR, UPDATE_DEADLINE_OKR, UPDATE_STATUS_OKR} from "@/core/services/store/okrs/okr.module";


export default {
  name: 'TableOKRs',
  components: {TableShareExp, FormOKR},
  props: {
    dataOkrs: {
      type: Array,
      required: true,
      default: () => []
    },
    page: {
      type: Number,
      required: true,
      default: 1
    }
  },
  data() {
    return {
      statusOkrOption,
      isEdit: false,
      okrSelected: {},
      isShare: false,
      isDelete: false,
      disabledSubmit: false,
    }
  },
  methods: {
    getIndex(page, index, limit) {
      return this.getIndexPaginate(page, index, limit)
    },
    updateOkr(okr) {
      this.isEdit = true
      this.okrSelected = okr
    },
    confirmDeleteOkr(okr) {
      this.isDelete = true
      this.okrSelected = okr
    },
    handleDeleteOkr() {
      this.disabledSubmit = true
      this.$store.dispatch(DELETE_OKR, this.okrSelected.id).then(res => {
        if (!res.error) {
          this.$message.success('Xoá okr thành công!')
          this.getListOkr()
          this.isDelete = false
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => this.disabledSubmit = false)
    },
    handleShareExp(okr) {
      this.isShare = true
      this.okrSelected = okr
    },
    updateStatusOkr(item) {
      const payload = {
        id: item.id,
        status: item.status
      }
      this.$store.dispatch(UPDATE_STATUS_OKR, payload).then(res => {
        if (!res.error) {
          this.getListOkr()
          this.$message.success('Cập nhật trạng thái thành công !')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    updateDeadline(item) {
      if (item.deadline && +item.deadline > 100) {
        this.$message.warning('Tiến độ không được vượt quá 100%')
        return;
      }
      const payload = {
        id: item.id,
        completion_rate: item.deadline
      }
      this.$store.dispatch(UPDATE_DEADLINE_OKR, payload).then(res => {
        if (!res.error) {
          this.getListOkr()
          this.$message.success('Cập nhật tiến độ thành công !')
        }
      })
    },
    getListOkr() {
      this.$emit('getListOkr');
    }
  }
}
</script>

<style>
.color-violet {
  color: #3A057B;
}
.color-green {
  color: green !important;
}
#success-okr .el-input__inner {
  color: green;
}
#fail-okr .el-input__inner {
  color: red;
}
#warning-okr .el-input__inner {
  color: #ffc241;
}
#normal-okr .el-input__inner {
  color: black;
}
</style>
